import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_2cde61f5 from 'nuxt_plugin_plugin_2cde61f5' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_sentryserver_12fa194f from 'nuxt_plugin_sentryserver_12fa194f' // Source: ./sentry.server.js (mode: 'server')
import nuxt_plugin_sentryclient_a57eb072 from 'nuxt_plugin_sentryclient_a57eb072' // Source: ./sentry.client.js (mode: 'client')
import nuxt_plugin_plugin_99a7a3ce from 'nuxt_plugin_plugin_99a7a3ce' // Source: ./vuetify/plugin.js (mode: 'all')
import nuxt_plugin_plugin_3de661c6 from 'nuxt_plugin_plugin_3de661c6' // Source: ./composition-api/plugin.mjs (mode: 'all')
import nuxt_plugin_storeregisterStore3de67b94_bba345f0 from 'nuxt_plugin_storeregisterStore3de67b94_bba345f0' // Source: ./store.registerStore.3de67b94.js (mode: 'all')
import nuxt_plugin_storeregisterStore7737a03e_60de31ea from 'nuxt_plugin_storeregisterStore7737a03e_60de31ea' // Source: ./store.registerStore.7737a03e.js (mode: 'all')
import nuxt_plugin_storeregisterStoreb8382d44_5ed707ba from 'nuxt_plugin_storeregisterStoreb8382d44_5ed707ba' // Source: ./store.registerStore.b8382d44.js (mode: 'all')
import nuxt_plugin_storeregisterStore0ab4e28c_acdccf16 from 'nuxt_plugin_storeregisterStore0ab4e28c_acdccf16' // Source: ./store.registerStore.0ab4e28c.js (mode: 'all')
import nuxt_plugin_storeregisterStore33fab14c_761413f7 from 'nuxt_plugin_storeregisterStore33fab14c_761413f7' // Source: ./store.registerStore.33fab14c.js (mode: 'all')
import nuxt_plugin_storeregisterStore0a4071f2_35c13106 from 'nuxt_plugin_storeregisterStore0a4071f2_35c13106' // Source: ./store.registerStore.0a4071f2.js (mode: 'all')
import nuxt_plugin_storeregisterStore1dfe8360_03870189 from 'nuxt_plugin_storeregisterStore1dfe8360_03870189' // Source: ./store.registerStore.1dfe8360.js (mode: 'all')
import nuxt_plugin_storeregisterStore055b4817_3115cb74 from 'nuxt_plugin_storeregisterStore055b4817_3115cb74' // Source: ./store.registerStore.055b4817.js (mode: 'all')
import nuxt_plugin_storeregisterStore17a0d188_801c0c64 from 'nuxt_plugin_storeregisterStore17a0d188_801c0c64' // Source: ./store.registerStore.17a0d188.js (mode: 'all')
import nuxt_plugin_storeregisterStoree978b33a_6c31c47c from 'nuxt_plugin_storeregisterStoree978b33a_6c31c47c' // Source: ./store.registerStore.e978b33a.js (mode: 'all')
import nuxt_plugin_storeregisterStore79c4e514_2943c5ca from 'nuxt_plugin_storeregisterStore79c4e514_2943c5ca' // Source: ./store.registerStore.79c4e514.js (mode: 'all')
import nuxt_plugin_storeregisterStore7e226684_40da3a66 from 'nuxt_plugin_storeregisterStore7e226684_40da3a66' // Source: ./store.registerStore.7e226684.js (mode: 'all')
import nuxt_plugin_storeregisterStore101a08c4_76beacc8 from 'nuxt_plugin_storeregisterStore101a08c4_76beacc8' // Source: ./store.registerStore.101a08c4.js (mode: 'all')
import nuxt_plugin_storeregisterStore0538caa6_0709d1da from 'nuxt_plugin_storeregisterStore0538caa6_0709d1da' // Source: ./store.registerStore.0538caa6.js (mode: 'all')
import nuxt_plugin_storeregisterStore743e9ba0_9e185bae from 'nuxt_plugin_storeregisterStore743e9ba0_9e185bae' // Source: ./store.registerStore.743e9ba0.js (mode: 'all')
import nuxt_plugin_storeregisterStore043e9404_4d83541b from 'nuxt_plugin_storeregisterStore043e9404_4d83541b' // Source: ./store.registerStore.043e9404.js (mode: 'all')
import nuxt_plugin_storeregisterStorea271d9d8_0a1e0e3c from 'nuxt_plugin_storeregisterStorea271d9d8_0a1e0e3c' // Source: ./store.registerStore.a271d9d8.js (mode: 'all')
import nuxt_plugin_storeregisterStore12c55e84_66325f1e from 'nuxt_plugin_storeregisterStore12c55e84_66325f1e' // Source: ./store.registerStore.12c55e84.js (mode: 'all')
import nuxt_plugin_workbox_405cda32 from 'nuxt_plugin_workbox_405cda32' // Source: ./workbox.js (mode: 'client')
import nuxt_plugin_metaplugin_113902fa from 'nuxt_plugin_metaplugin_113902fa' // Source: ./pwa/meta.plugin.js (mode: 'all')
import nuxt_plugin_toast_06e4613a from 'nuxt_plugin_toast_06e4613a' // Source: ./toast.js (mode: 'client')
import nuxt_plugin_axios_3ab4148b from 'nuxt_plugin_axios_3ab4148b' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_portalvue_466cf6a8 from 'nuxt_plugin_portalvue_466cf6a8' // Source: ./portal-vue.js (mode: 'all')
import nuxt_plugin_vuescrollto_8a1861c4 from 'nuxt_plugin_vuescrollto_8a1861c4' // Source: ./vue-scrollto.js (mode: 'client')
import nuxt_plugin_axios_2228ef02 from 'nuxt_plugin_axios_2228ef02' // Source: ../plugins/axios (mode: 'all')
import nuxt_plugin_api_caeae0b4 from 'nuxt_plugin_api_caeae0b4' // Source: ../plugins/api (mode: 'all')
import nuxt_plugin_appFetch_c81169e6 from 'nuxt_plugin_appFetch_c81169e6' // Source: ../plugins/appFetch (mode: 'all')
import nuxt_plugin_emitter_0701aa0c from 'nuxt_plugin_emitter_0701aa0c' // Source: ../plugins/emitter (mode: 'client')
import nuxt_plugin_dayjs_2248fc71 from 'nuxt_plugin_dayjs_2248fc71' // Source: ../plugins/dayjs (mode: 'client')
import nuxt_plugin_confirmation_4b26f429 from 'nuxt_plugin_confirmation_4b26f429' // Source: ../plugins/confirmation (mode: 'all')
import nuxt_plugin_mapsclient_a66a9aae from 'nuxt_plugin_mapsclient_a66a9aae' // Source: ../plugins/maps.client.js (mode: 'client')
import nuxt_plugin_firebase_27cb801c from 'nuxt_plugin_firebase_27cb801c' // Source: ../plugins/firebase.js (mode: 'all')
import nuxt_plugin_theme_cc49f4fc from 'nuxt_plugin_theme_cc49f4fc' // Source: ../plugins/theme.js (mode: 'all')
import nuxt_plugin_auth_1e655745 from 'nuxt_plugin_auth_1e655745' // Source: ./auth.js (mode: 'all')
import nuxt_plugin_appinitappInitPluginc079a05c_012bfdb9 from 'nuxt_plugin_appinitappInitPluginc079a05c_012bfdb9' // Source: ./app-init.appInitPlugin.c079a05c.js (mode: 'all')
import nuxt_plugin_meta_1727cd6f from 'nuxt_plugin_meta_1727cd6f' // Source: ./composition-api/meta.mjs (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root.$options.$nuxt
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":true,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const router = await createRouter(ssrContext, config)

  const store = createStore(ssrContext)
  // Add this.$router into store actions/mutations
  store.$router = router

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"titleTemplate":"prodstor","title":"prodstor","meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1, maximum-scale=1"},{"hid":"description","name":"description","content":""},{"name":"format-detection","content":"telephone=no"},{"hid":"charset","charset":"utf-8"},{"hid":"mobile-web-app-capable","name":"mobile-web-app-capable","content":"yes"},{"hid":"apple-mobile-web-app-title","name":"apple-mobile-web-app-title","content":"good-choice"},{"hid":"og:type","name":"og:type","property":"og:type","content":"website"},{"hid":"og:title","name":"og:title","property":"og:title","content":"good-choice"},{"hid":"og:site_name","name":"og:site_name","property":"og:site_name","content":"good-choice"}],"link":[{"rel":"icon","type":"image\u002Fpng","href":"\u002Fprodstor-icon.png"},{"rel":"manifest","href":"\u002F_nuxt\u002Fmanifest.e07561ef.json","hid":"manifest"}],"style":[],"script":[],"htmlAttrs":{"lang":"ru"}},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_2cde61f5 === 'function') {
    await nuxt_plugin_plugin_2cde61f5(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_sentryserver_12fa194f === 'function') {
    await nuxt_plugin_sentryserver_12fa194f(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_sentryclient_a57eb072 === 'function') {
    await nuxt_plugin_sentryclient_a57eb072(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin_99a7a3ce === 'function') {
    await nuxt_plugin_plugin_99a7a3ce(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin_3de661c6 === 'function') {
    await nuxt_plugin_plugin_3de661c6(app.context, inject)
  }

  if (typeof nuxt_plugin_storeregisterStore3de67b94_bba345f0 === 'function') {
    await nuxt_plugin_storeregisterStore3de67b94_bba345f0(app.context, inject)
  }

  if (typeof nuxt_plugin_storeregisterStore7737a03e_60de31ea === 'function') {
    await nuxt_plugin_storeregisterStore7737a03e_60de31ea(app.context, inject)
  }

  if (typeof nuxt_plugin_storeregisterStoreb8382d44_5ed707ba === 'function') {
    await nuxt_plugin_storeregisterStoreb8382d44_5ed707ba(app.context, inject)
  }

  if (typeof nuxt_plugin_storeregisterStore0ab4e28c_acdccf16 === 'function') {
    await nuxt_plugin_storeregisterStore0ab4e28c_acdccf16(app.context, inject)
  }

  if (typeof nuxt_plugin_storeregisterStore33fab14c_761413f7 === 'function') {
    await nuxt_plugin_storeregisterStore33fab14c_761413f7(app.context, inject)
  }

  if (typeof nuxt_plugin_storeregisterStore0a4071f2_35c13106 === 'function') {
    await nuxt_plugin_storeregisterStore0a4071f2_35c13106(app.context, inject)
  }

  if (typeof nuxt_plugin_storeregisterStore1dfe8360_03870189 === 'function') {
    await nuxt_plugin_storeregisterStore1dfe8360_03870189(app.context, inject)
  }

  if (typeof nuxt_plugin_storeregisterStore055b4817_3115cb74 === 'function') {
    await nuxt_plugin_storeregisterStore055b4817_3115cb74(app.context, inject)
  }

  if (typeof nuxt_plugin_storeregisterStore17a0d188_801c0c64 === 'function') {
    await nuxt_plugin_storeregisterStore17a0d188_801c0c64(app.context, inject)
  }

  if (typeof nuxt_plugin_storeregisterStoree978b33a_6c31c47c === 'function') {
    await nuxt_plugin_storeregisterStoree978b33a_6c31c47c(app.context, inject)
  }

  if (typeof nuxt_plugin_storeregisterStore79c4e514_2943c5ca === 'function') {
    await nuxt_plugin_storeregisterStore79c4e514_2943c5ca(app.context, inject)
  }

  if (typeof nuxt_plugin_storeregisterStore7e226684_40da3a66 === 'function') {
    await nuxt_plugin_storeregisterStore7e226684_40da3a66(app.context, inject)
  }

  if (typeof nuxt_plugin_storeregisterStore101a08c4_76beacc8 === 'function') {
    await nuxt_plugin_storeregisterStore101a08c4_76beacc8(app.context, inject)
  }

  if (typeof nuxt_plugin_storeregisterStore0538caa6_0709d1da === 'function') {
    await nuxt_plugin_storeregisterStore0538caa6_0709d1da(app.context, inject)
  }

  if (typeof nuxt_plugin_storeregisterStore743e9ba0_9e185bae === 'function') {
    await nuxt_plugin_storeregisterStore743e9ba0_9e185bae(app.context, inject)
  }

  if (typeof nuxt_plugin_storeregisterStore043e9404_4d83541b === 'function') {
    await nuxt_plugin_storeregisterStore043e9404_4d83541b(app.context, inject)
  }

  if (typeof nuxt_plugin_storeregisterStorea271d9d8_0a1e0e3c === 'function') {
    await nuxt_plugin_storeregisterStorea271d9d8_0a1e0e3c(app.context, inject)
  }

  if (typeof nuxt_plugin_storeregisterStore12c55e84_66325f1e === 'function') {
    await nuxt_plugin_storeregisterStore12c55e84_66325f1e(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_workbox_405cda32 === 'function') {
    await nuxt_plugin_workbox_405cda32(app.context, inject)
  }

  if (typeof nuxt_plugin_metaplugin_113902fa === 'function') {
    await nuxt_plugin_metaplugin_113902fa(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_toast_06e4613a === 'function') {
    await nuxt_plugin_toast_06e4613a(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_3ab4148b === 'function') {
    await nuxt_plugin_axios_3ab4148b(app.context, inject)
  }

  if (typeof nuxt_plugin_portalvue_466cf6a8 === 'function') {
    await nuxt_plugin_portalvue_466cf6a8(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuescrollto_8a1861c4 === 'function') {
    await nuxt_plugin_vuescrollto_8a1861c4(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_2228ef02 === 'function') {
    await nuxt_plugin_axios_2228ef02(app.context, inject)
  }

  if (typeof nuxt_plugin_api_caeae0b4 === 'function') {
    await nuxt_plugin_api_caeae0b4(app.context, inject)
  }

  if (typeof nuxt_plugin_appFetch_c81169e6 === 'function') {
    await nuxt_plugin_appFetch_c81169e6(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_emitter_0701aa0c === 'function') {
    await nuxt_plugin_emitter_0701aa0c(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_dayjs_2248fc71 === 'function') {
    await nuxt_plugin_dayjs_2248fc71(app.context, inject)
  }

  if (typeof nuxt_plugin_confirmation_4b26f429 === 'function') {
    await nuxt_plugin_confirmation_4b26f429(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_mapsclient_a66a9aae === 'function') {
    await nuxt_plugin_mapsclient_a66a9aae(app.context, inject)
  }

  if (typeof nuxt_plugin_firebase_27cb801c === 'function') {
    await nuxt_plugin_firebase_27cb801c(app.context, inject)
  }

  if (typeof nuxt_plugin_theme_cc49f4fc === 'function') {
    await nuxt_plugin_theme_cc49f4fc(app.context, inject)
  }

  if (typeof nuxt_plugin_auth_1e655745 === 'function') {
    await nuxt_plugin_auth_1e655745(app.context, inject)
  }

  if (typeof nuxt_plugin_appinitappInitPluginc079a05c_012bfdb9 === 'function') {
    await nuxt_plugin_appinitappInitPluginc079a05c_012bfdb9(app.context, inject)
  }

  if (typeof nuxt_plugin_meta_1727cd6f === 'function') {
    await nuxt_plugin_meta_1727cd6f(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
